var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c(
          "div",
          { staticClass: "header-inner row align-items-center" },
          [
            _c("div", { staticClass: "col left" }, [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("sidebar.goodsreceipt")) +
                      "\n          "
                  ),
                  _vm.ready
                    ? [
                        _vm._v(
                          "\n            >\n            " +
                            _vm._s(_vm.goodsreceipt.gr_code) +
                            "\n          "
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _vm.device.isMobile
              ? [
                  _c("div", { staticClass: "col-7 right pl-0" }, [
                    _vm.goodsreceipt !== null
                      ? _c(
                          "div",
                          { staticClass: "action" },
                          [
                            _vm.showOptionButton
                              ? _c("div", { staticClass: "dropdown item" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn no-bg dropdown-toggle text-secondary shake",
                                      attrs: {
                                        id: "dropdownMenuButton",
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false"
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "fas fa-cog" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(_vm.$t("button.options")))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                      attrs: {
                                        "aria-labelledby": "dropdownMenuButton"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function($event) {
                                              return _vm.openCloneModal()
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-copy"
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "name" }, [
                                            _vm._v(
                                              _vm._s(_vm.$t("button.clone"))
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function($event) {
                                              return _vm.openPrintModal()
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-print"
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "name" }, [
                                            _vm._v(
                                              _vm._s(_vm.$t("button.print"))
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.hasRoleDelete
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function($event) {
                                                  return _vm.openConfirmdeleteModal()
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-trash text-danger"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("button.delete")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.goodsreceipt.status == "padding" &&
                            _vm.hasRoleEdit
                              ? _c("div", { staticClass: "dropdown item" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn no-bg dropdown-toggle text-info",
                                      attrs: {
                                        id: "dropdownMenuButton",
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false"
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "far fa-circle" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.gr.padding"))
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                      attrs: {
                                        "aria-labelledby": "dropdownMenuButton"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function($event) {
                                              return _vm.openReceivedorderModal()
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "far fa-check-circle text-success",
                                            staticStyle: {
                                              position: "relative",
                                              left: "-7px"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-success" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("status.gr.done"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : [
                                  _vm.goodsreceipt.status == "padding"
                                    ? _c(
                                        "div",
                                        { staticClass: "dropdown item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-info" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("status.gr.padding")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.goodsreceipt.status == "done"
                                    ? _c(
                                        "div",
                                        { staticClass: "dropdown item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-success" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("status.gr.done")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ]
              : [
                  _c("div", { staticClass: "col-7 right" }, [
                    _vm.goodsreceipt !== null
                      ? _c(
                          "div",
                          { staticClass: "action" },
                          [
                            _vm.showOptionButton
                              ? _c("div", { staticClass: "dropdown item" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn no-bg dropdown-toggle text-secondary shake",
                                      attrs: {
                                        id: "dropdownMenuButton",
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false"
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "fas fa-cog" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(_vm.$t("button.options")))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                      attrs: {
                                        "aria-labelledby": "dropdownMenuButton"
                                      }
                                    },
                                    [
                                      _vm.hasRoleDelete
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function($event) {
                                                  return _vm.openConfirmdeleteModal()
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-trash text-danger"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("button.delete")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown nodro item" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn no-bg text-secondary",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.openCloneModal()
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fas fa-copy" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(_vm.$t("button.clone")))
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown nodro item" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn no-bg text-secondary",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.openPrintModal()
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fas fa-print" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(_vm.$t("button.print")))
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.goodsreceipt.status == "padding" &&
                            _vm.hasRoleEdit
                              ? _c("div", { staticClass: "dropdown item" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn no-bg dropdown-toggle text-info",
                                      attrs: {
                                        id: "dropdownMenuButton",
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false"
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "far fa-circle" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.gr.padding"))
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                      attrs: {
                                        "aria-labelledby": "dropdownMenuButton"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function($event) {
                                              return _vm.openReceivedorderModal()
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "far fa-check-circle text-success",
                                            staticStyle: {
                                              position: "relative",
                                              left: "-7px"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-success" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("status.gr.done"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : [
                                  _vm.goodsreceipt.status == "padding"
                                    ? _c(
                                        "div",
                                        { staticClass: "dropdown item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-info" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("status.gr.padding")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.goodsreceipt.status == "done"
                                    ? _c(
                                        "div",
                                        { staticClass: "dropdown item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-success" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("status.gr.done")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready
            ? [
                _c("WrapperDoc", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "form",
                        fn: function() {
                          return [
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("section-header", {
                                    attrs: {
                                      title: _vm.$t("message.vendor"),
                                      subtitle:
                                        _vm.$t("series.gr") +
                                        " " +
                                        _vm.goodsreceipt.gr_code
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.storecompanyperson"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("selectize", {
                                                attrs: {
                                                  default:
                                                    _vm.form.defaultVendorId,
                                                  updateoption:
                                                    _vm.form.updateOptionVendor,
                                                  options:
                                                    _vm.form.optionVendors,
                                                  multiple: false,
                                                  create: true,
                                                  loading:
                                                    _vm.form.loadingVendor,
                                                  validation:
                                                    _vm.form
                                                      .trickValidationVendor,
                                                  placeholder: _vm.$t(
                                                    "placeholder.selectorcreate"
                                                  ),
                                                  disabled: _vm.disabledForm
                                                },
                                                on: { add: _vm.onAddedVendor },
                                                model: {
                                                  value:
                                                    _vm.form.pickedVendorId,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "pickedVendorId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.pickedVendorId"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm.form.pickedVendorId
                                    ? _c("div", { staticClass: "form-row" }, [
                                        _c("div", { staticClass: "col-md-6" }, [
                                          _c(
                                            "div",
                                            { staticClass: "form-group row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.address"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("textarea", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form.vendor
                                                            .address,
                                                        expression:
                                                          "form.vendor.address"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    staticStyle: {
                                                      "min-height": "107px"
                                                    },
                                                    attrs: {
                                                      disabled: _vm.disabledForm
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.form.vendor.address
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.form.vendor,
                                                          "address",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-6" }, [
                                          _c(
                                            "div",
                                            { staticClass: "form-group row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("message.tel")
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form.vendor.tel,
                                                        expression:
                                                          "form.vendor.tel"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      disabled:
                                                        _vm.disabledForm,
                                                      type: "text"
                                                    },
                                                    domProps: {
                                                      value: _vm.form.vendor.tel
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.form.vendor,
                                                          "tel",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "form-group row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("message.email")
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.form.vendor.email,
                                                        expression:
                                                          "form.vendor.email"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      disabled:
                                                        _vm.disabledForm,
                                                      type: "text"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.form.vendor.email
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.form.vendor,
                                                          "email",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("section-header", {
                                    attrs: { title: _vm.$t("message.date") }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "apps.inventory.message.receiptdate"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("BaseInputDatePicker", {
                                                attrs: {
                                                  disabled: _vm.disabledForm,
                                                  mode: "dateTime",
                                                  is24hr: ""
                                                },
                                                model: {
                                                  value: _vm.form.selectedDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "selectedDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.selectedDate"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.goodsreceipt.posting_at
                                      ? _c("div", { staticClass: "col-md-6" }, [
                                          _c(
                                            "div",
                                            { staticClass: "form-group row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "apps.inventory.message.postingatreceivedorders"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    staticClass: "form-control",
                                                    class: [
                                                      {
                                                        "text-danger":
                                                          _vm.goodsreceipt
                                                            .posting_at == null
                                                      },
                                                      {
                                                        "text-success":
                                                          _vm.goodsreceipt
                                                            .posting_at !== null
                                                      }
                                                    ],
                                                    attrs: {
                                                      disabled: true,
                                                      type: "text"
                                                    },
                                                    domProps: {
                                                      value: _vm.goodsreceipt
                                                        .posting_at
                                                        ? _vm.getDateTime(
                                                            _vm.goodsreceipt
                                                              .posting_at
                                                          )
                                                        : "-"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("section-header", {
                                    attrs: {
                                      title: _vm.$t(
                                        "apps.inventory.message.shipto"
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.store")
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.form
                                                          .pickedWarehouseId,
                                                      expression:
                                                        "form.pickedWarehouseId"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-control custom-select",
                                                  attrs: { disabled: true },
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.$set(
                                                        _vm.form,
                                                        "pickedWarehouseId",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    }
                                                  }
                                                },
                                                _vm._l(_vm.warehouses, function(
                                                  item,
                                                  index
                                                ) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: index,
                                                      attrs: {
                                                        disabled:
                                                          _vm.disabledForm
                                                      },
                                                      domProps: {
                                                        value: item.warehouse_id
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            item.warehouse_name
                                                          ) +
                                                          "\n                        "
                                                      )
                                                    ]
                                                  )
                                                }),
                                                0
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("section-header", {
                                    attrs: {
                                      title: _vm.$t("message.orderlist")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("OrderGR", {
                                    attrs: {
                                      validation: _vm.form.trickValidation,
                                      data: _vm.form.orders,
                                      createAble: true,
                                      showProductImage: true,
                                      selectedWhId: _vm.form.pickedWarehouseId,
                                      disabled: _vm.disabledForm,
                                      optionBinLocations: _vm.optionBinLocations
                                    },
                                    on: { submit: _vm.onSubmitOrder }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("placeholder.note")
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("textarea", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.form.note,
                                                    expression: "form.note"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "placeholder.dotted"
                                                  ),
                                                  disabled: _vm.disabledForm
                                                },
                                                domProps: {
                                                  value: _vm.form.note
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.form,
                                                      "note",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            !_vm.disabledForm
                              ? _c(
                                  "section",
                                  { staticClass: "action-bar" },
                                  [
                                    [
                                      !_vm.$store.state.app.loading
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 text-right"
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "btn btn-web",
                                                  on: {
                                                    click: function($event) {
                                                      _vm.form.trickValidation++
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("button.save")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 text-right"
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-web btn-block-mobile-only",
                                                  attrs: { disabled: "" }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-spinner spin"
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                    ]
                                  ],
                                  2
                                )
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "ref",
                        fn: function() {
                          return [
                            _c("DocRef", {
                              attrs: {
                                refDoc: "gr",
                                refId: _vm.goodsreceipt.gr_id,
                                refCode: _vm.goodsreceipt.gr_code,
                                showLog:
                                  _vm.getInventorySetting.log_topic.is_active,
                                showAttachFile:
                                  _vm.getInventorySetting.attach_file.is_active,
                                logTopics:
                                  _vm.getInventorySetting.log_topic.options,
                                isSubmitted: _vm.isSubmitted
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    233755710
                  )
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "doneModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "pricesModalTitle",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg-1000",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("apps.inventory.message.receivedorders_header")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.$store.state.app.loading
                    ? _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "modal",
                            "aria-label": "Close"
                          },
                          on: {
                            click: function($event) {
                              return _vm.cancel()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "section",
                    { staticClass: "mb-3" },
                    [
                      _c("section-title", {
                        attrs: {
                          title:
                            _vm.$t("message.productlist") +
                            " (" +
                            _vm.doneOrders.length +
                            ")"
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.doneOrders, function(data, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "col-12 box mb-2" },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c("div", { staticClass: "form-row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-12 col-lg-6 mb-mobile-2"
                                    },
                                    [
                                      _c("BaseInput", {
                                        attrs: {
                                          value: data.item,
                                          disabled: true
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-6 col-lg-3" }, [
                                    _c("div", { staticClass: "input-group" }, [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "input-group-text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.message.initialdemand"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        staticClass:
                                          "form-control text-right number-only text-select-all",
                                        attrs: { disabled: true, type: "text" },
                                        domProps: { value: data.quantity }
                                      })
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-6 col-lg-3" }, [
                                    _c("div", { staticClass: "input-group" }, [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "input-group-text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "apps.inventory.message.receivedcount"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.doneOrders[index].done,
                                            expression: "doneOrders[index].done"
                                          }
                                        ],
                                        staticClass:
                                          "form-control text-right number-only text-select-all textfield-done",
                                        attrs: {
                                          disabled:
                                            _vm.isUseLot(data.sku_id) ||
                                            _vm.isUseSerial(data.sku_id),
                                          type: "number",
                                          placeholder: "0"
                                        },
                                        domProps: {
                                          value: _vm.doneOrders[index].done
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.checkReceivedNumber(
                                              _vm.doneOrders[index]
                                            )
                                          },
                                          keyup: function($event) {
                                            return _vm.checkReceivedNumber(
                                              _vm.doneOrders[index]
                                            )
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.doneOrders[index],
                                              "done",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.isUseLot(data.sku_id) && data.lot_number
                                  ? _c(
                                      "div",
                                      { staticClass: "form-row mt-2" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12",
                                            staticStyle: {
                                              "margin-bottom": "-10px"
                                            }
                                          },
                                          [
                                            _c("section-title", {
                                              attrs: {
                                                title: _vm.$t(
                                                  "apps.inventory.label.lotnumber"
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-12 mt-2" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-row" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-6" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 mb-2"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-prepend"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "input-group-text",
                                                                        staticStyle: {
                                                                          "min-width":
                                                                            "100px"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "apps.inventory.label.bin"
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  staticClass:
                                                                    "form-control text-right",
                                                                  attrs: {
                                                                    disabled: true
                                                                  },
                                                                  domProps: {
                                                                    value: _vm.getBinName(
                                                                      data
                                                                        .lot_number
                                                                        .bin_location_id
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 mb-2"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-prepend"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "input-group-text",
                                                                        staticStyle: {
                                                                          "min-width":
                                                                            "100px"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "apps.inventory.label.dateproduct"
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  staticClass:
                                                                    "form-control text-right",
                                                                  attrs: {
                                                                    disabled: true
                                                                  },
                                                                  domProps: {
                                                                    value: data
                                                                      .lot_number
                                                                      .date_product
                                                                      ? _vm.getDate(
                                                                          data
                                                                            .lot_number
                                                                            .date_product
                                                                        )
                                                                      : null
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12 mb-2"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-prepend"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "input-group-text",
                                                                        staticStyle: {
                                                                          "min-width":
                                                                            "100px"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "apps.inventory.label.dateexpire"
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  staticClass:
                                                                    "form-control text-right",
                                                                  attrs: {
                                                                    disabled: true
                                                                  },
                                                                  domProps: {
                                                                    value: data
                                                                      .lot_number
                                                                      .date_expire
                                                                      ? _vm.getDate(
                                                                          data
                                                                            .lot_number
                                                                            .date_expire
                                                                        )
                                                                      : null
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-prepend"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "input-group-text",
                                                                        staticStyle: {
                                                                          "min-width":
                                                                            "100px"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "apps.inventory.label.cost"
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "BaseInputNumber",
                                                                  {
                                                                    staticClass:
                                                                      "text-right",
                                                                    attrs: {
                                                                      value:
                                                                        data
                                                                          .lot_number
                                                                          .cost,
                                                                      disabled: true
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isUseSerial(data.sku_id) &&
                                data.serial_numbers
                                  ? _c(
                                      "div",
                                      { staticClass: "form-row mt-2" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12",
                                            staticStyle: {
                                              "margin-bottom": "-10px"
                                            }
                                          },
                                          [
                                            _c("section-title", {
                                              attrs: {
                                                title: _vm.$t(
                                                  "apps.inventory.label.serialnumber"
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(data.serial_numbers, function(
                                          serial,
                                          serIndex
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: serIndex,
                                              staticClass: "col-12 mt-2"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-6" },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-12 mb-2"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-prepend"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "input-group-text",
                                                                          staticStyle: {
                                                                            "min-width":
                                                                              "100px"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "apps.inventory.label.bin"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    staticClass:
                                                                      "form-control text-right",
                                                                    attrs: {
                                                                      disabled: true
                                                                    },
                                                                    domProps: {
                                                                      value: _vm.getBinName(
                                                                        serial.bin_location_id
                                                                      )
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-12 mb-2"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-prepend"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "input-group-text",
                                                                          staticStyle: {
                                                                            "min-width":
                                                                              "100px"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "apps.inventory.label.serialnumber"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    staticClass:
                                                                      "form-control text-right",
                                                                    attrs: {
                                                                      disabled: true
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        serial.serial_number
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-12 mb-2"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-prepend"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "input-group-text",
                                                                          staticStyle: {
                                                                            "min-width":
                                                                              "100px"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "apps.inventory.label.dateproduct"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    staticClass:
                                                                      "form-control text-right",
                                                                    attrs: {
                                                                      disabled: true
                                                                    },
                                                                    domProps: {
                                                                      value: serial.date_product
                                                                        ? _vm.getDate(
                                                                            serial.date_product
                                                                          )
                                                                        : null
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-12 mb-2"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-prepend"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "input-group-text",
                                                                          staticStyle: {
                                                                            "min-width":
                                                                              "100px"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "apps.inventory.label.dateexpire"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("input", {
                                                                    staticClass:
                                                                      "form-control text-right",
                                                                    attrs: {
                                                                      disabled: true
                                                                    },
                                                                    domProps: {
                                                                      value: serial.date_expire
                                                                        ? _vm.getDate(
                                                                            serial.date_expire
                                                                          )
                                                                        : null
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-12"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-prepend"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "input-group-text",
                                                                          staticStyle: {
                                                                            "min-width":
                                                                              "100px"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "apps.inventory.label.cost"
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "BaseInputNumber",
                                                                    {
                                                                      staticClass:
                                                                        "text-right",
                                                                      attrs: {
                                                                        value:
                                                                          serial.cost,
                                                                        disabled: true
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              serIndex <
                                              data.serial_numbers.length - 1
                                                ? _c(
                                                    "div",
                                                    { staticClass: "form-row" },
                                                    [_vm._m(0, true)]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-row mt-2" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12" },
                                    [
                                      _c("section-title", {
                                        attrs: {
                                          title: _vm.$t(
                                            "apps.inventory.message.newresult"
                                          )
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-12" }, [
                                    _c("div", { staticClass: "input-group" }, [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "input-group-text",
                                              staticStyle: {
                                                "border-radius": "0.25em 0 0 0"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.getWhLocationName(
                                                      _vm.form
                                                        .pickedWarehouseId,
                                                      data.bin_location_id
                                                    )
                                                  ) +
                                                  "\n                          "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        staticClass: "form-control text-right",
                                        staticStyle: {
                                          "border-left": "0",
                                          "border-radius": "0 0.25em 0 0"
                                        },
                                        attrs: { disabled: true, type: "text" },
                                        domProps: {
                                          value: _vm.inStockTotal(
                                            data.sku_id,
                                            data.stock_id,
                                            data.bin_location_id
                                          )
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "input-group" }, [
                                      _vm._m(1, true),
                                      _vm._v(" "),
                                      _c("input", {
                                        class: [
                                          "form-control text-right",
                                          _vm.inStockTotalAfterSubmit(
                                            data.sku_id,
                                            data.stock_id,
                                            data.bin_location_id,
                                            _vm.doneOrders[index].done
                                          ) <= -1
                                            ? "text-danger"
                                            : ""
                                        ],
                                        staticStyle: {
                                          "border-left": "0px",
                                          "border-top": "0",
                                          "border-radius": "0 0 0.25em 0"
                                        },
                                        attrs: { disabled: true, type: "text" },
                                        domProps: {
                                          value: _vm.inStockTotalAfterSubmit(
                                            data.sku_id,
                                            data.stock_id,
                                            data.bin_location_id,
                                            _vm.doneOrders[index].done
                                          )
                                        }
                                      })
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    [
                      _c("section-title", {
                        attrs: {
                          title:
                            _vm.$t(
                              "apps.inventory.message.postingatreceivedorders"
                            ) +
                            " & " +
                            _vm.$t("message.note")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-lg-4 mb-mobile-2" },
                          [
                            _c("div", { staticClass: "form-row" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "input-group" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "input-group-prepend",
                                        staticStyle: { "max-width": "98px" }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "input-group-text text-lowercase"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "apps.inventory.message.postingatreceivedorders"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("BaseInputDatePicker", {
                                      attrs: { mode: "dateTime", is24hr: "" },
                                      model: {
                                        value: _vm.form.posting_at,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "posting_at", $$v)
                                        },
                                        expression: "form.posting_at"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-lg-8" }, [
                          _c("div", { staticClass: "col-md-12 no-padding" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.note,
                                  expression: "form.note"
                                }
                              ],
                              staticClass: "form-control",
                              staticStyle: { height: "31px !important" },
                              attrs: { placeholder: _vm.$t("message.note") },
                              domProps: { value: _vm.form.note },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "note",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                !_vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: {
                            click: function($event) {
                              return _vm.cancel()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-web",
                          attrs: {
                            disabled: _vm.form.checkboxRespondBy == false,
                            type: "button"
                          },
                          on: {
                            click: function($event) {
                              return _vm.done()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.confirm")))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: {
                            type: "button",
                            "data-dismiss": "modal",
                            disabled: ""
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _vm._m(2)
                    ])
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "confirmdeleteModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "pricesModalTitle",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog ", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-header",
                    staticStyle: { "border-bottom": "none" }
                  },
                  [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.areyousuretodeletethis")) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    !_vm.$store.state.app.loading
                      ? _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: { type: "button", "aria-label": "Close" },
                            on: {
                              click: function($event) {
                                return _vm.closeConfirmdeleteModal()
                              }
                            }
                          },
                          [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("×")
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                !_vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.closeConfirmdeleteModal()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.del()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.delete")))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button", disabled: "" }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _vm._m(3)
                    ])
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "printModal",
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg-90-percent",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-body p-0",
                    staticStyle: {
                      background: "#C9CCCE",
                      height: "660px",
                      overflow: "auto"
                    }
                  },
                  [
                    _vm.ready
                      ? _c("print-gr", {
                          staticClass: "print-template",
                          attrs: { goodsreceipt: _vm.goodsreceipt }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-web",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.onclickPrint()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.print")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.closePrintModal()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.close")))]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      }),
      _vm._v(" "),
      _c("BaseConfirmCloneModal", {
        attrs: {
          show: _vm.modalConfirmClone.show,
          loading: _vm.modalConfirmClone.loading
        },
        on: {
          onClose: _vm.handleCloseCloneModal,
          onCancel: _vm.handleCancleCloneModal,
          onConfirm: function($event) {
            return _vm.handleConfirmCloneModal({
              payload: _vm.payloadClone,
              createApiFn: _vm.insertGoodsreceipt,
              redirectTo: "GoodsReceiptAll",
              refCode: "goodsreceipt.gr_code"
            })
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6" }, [
      _c("hr", { staticStyle: { margin: "15px 0 5px 0" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "span",
        {
          staticClass: "input-group-text",
          staticStyle: { "border-top": "0px", "border-radius": "0 0 0 0.25em" }
        },
        [_c("i", { staticClass: "fas fa-sync-alt" })]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-danger",
        attrs: { type: "button", disabled: "" }
      },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1081a677", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1081a677","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/goodsreceipt/Edit.vue
// module id = null
// module chunks = 